<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table #pt [value]="activities" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="activityId"
  selectionMode="single" [(selection)]="activity" (onRowSelect)="onRowSelect($event)"
  [loading]="loading" [paginator]="showPagination" [rows]="25" [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true" class="edit_filterList">

  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center">
      @if (!activityProviderId) {
        <h1 style="float: left;margin: 6px;">Activity</h1>
      }
      <span>
        <!--clear filters-->
        @if (showFilter) {
          <button pButton pRipple class="p-button-text"
            style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="reloadPage()">Clear Filters</button>
        }

        <!--add new-->
        <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
        (click)="onOpenFormAdd1()" [mat-dialog-close]="true">New Activity +</button>
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
    @if (showFilter) {
      <tr>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'name', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'status', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'activityType', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'invoiceType', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'activityProviderVO.activityProviderId', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"></th>
      </tr>
    }
  </ng-template>
  <ng-template pTemplate="body" let-activity>
    <tr [pSelectableRow]="activity" [mat-dialog-close]="true">
      <td>{{activity.name}}</td>
      <td>{{getStatusName(activity)}}</td>
      <td>{{activity.activityType}}</td>
      <td>{{activity.invoiceType}}</td>
      <td>{{activity.activityProviderId}}</td>
      <td><span style="float:none">
        <a>
          <mat-icon style="color:blue; font-size:110%; padding-right:20px;"
          (click)="onOpenFormEdit1(activity)">edit</mat-icon>
        </a>
      </span>
    </td>
  </tr>
</ng-template>
</p-table>